const idID = {
  // Claim Forms
  'claimForms.title': 'Formulir Klaim',
  'claimForms.photoTooSmall': 'Photo terlalu kecil, min 10kb',
  'claimForms.photoTooLarge': 'Photo terlalu besar, max 5mb',
  'claimForms.videoTooLarge': 'Video terlalu besar, max 10mb',
  'claimForms.maxFilesExceeded': 'Tidak dapat mengunggah lebih dari 50 file',
  'claimForms.fileAlreadyUploaded': 'File ini telah diunggah',
  'claimForms.uploadError': 'Ada yang bermasalah, reload dan ulangi kembali',
  'claimForms.checkFileType': 'Periksa jenis file Anda',
  'claimForms.allowedFileTypes': 'Hanya jenis file .jpg, .jpeg, .pdf, .png, .mp4, .mov, dan .avi yang diizinkan',
  'claimForms.error': 'Error',
  'claimForms.saved': 'Disimpan',
  'claimForms.saveDraft': 'Simpan Draft',
  'claimForms.save': 'Simpan',
  'claimForms.select': 'Pilih ...',
  'claimForms.agreeWith': 'Saya setuju dengan',
  'claimForms.termsAndConditions': 'Syarat & Ketentuan',
  'claimForms.fieldRequired': '{field} tidak boleh kosong',
  'claimForms.viewFile': 'Lihat File',
  'claimForms.uploadFile': 'Unggah File',
  'claimForms.changeFile': 'Ganti File',
  'claimForms.uploading': 'Mengunggah...',
  'claimForms.reupload': 'Unggah ulang',
  'claimForms.agree': 'Setuju',
  'claimForms.tcStatement1': 'Saya / Kami menyatakan bahwa semua informasi yang diberikan di atas adalah benar sesuai dengan pengetahuan dan kepercayaan saya / kami.',
  'claimForms.tcStatement2': 'Saya / Kami setuju untuk memberikan otoritas penuh kepada PT. Asuransi Simas Insurtech untuk memeriksa dan mensurvei jika diperlukan.',
  'claimForms.tcStatement3': 'Saya / Kami setuju jika saya / Kami membuat pernyataan salah / palsu terkait dengan klaim atau menyembunyikan sesuatu tentang fakta yang material dalam bentuk apa pun yang mengakibatkan Kebijakan dibatalkan dan kehilangan semua hak klaim saat ini dan masa depan.',
  // Create Claim
  'createClaim.title': 'Buat Klaim',
  'createClaim.success': 'Berhasil',
  'createClaim.error': 'Error',
  'createClaim.uploadPhotoError': 'Error mengupload foto',
  'createClaim.getBenefitsError': 'Error mendapatkan daftar manfaat',
  'createClaim.validationFailed': 'Validasi gagal',
  'createClaim.loading': 'Memuat...',
  'createClaim.noBenefitsFound': 'Manfaat tidak ditemukan',
  'createClaim.next': 'Berikutnya'
}

export default idID
